// extracted by mini-css-extract-plugin
export default {"logoMain":"LogoMain_logoMain__ggFUm","logoDots":"LogoMain_logoDots__eT+6h"};